import React from 'react';

import './styles.scss';

import pfrImage from '../../images/pfr.jpeg';

export const PFR = () => (
  <div className='pfr'>
    <img src={pfrImage} className="pfr__img" />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/PFR/index.js